import { render, staticRenderFns } from "./AttachFiles.vue?vue&type=template&id=221bd572&scoped=true"
import script from "./AttachFiles.vue?vue&type=script&lang=js"
export * from "./AttachFiles.vue?vue&type=script&lang=js"
import style0 from "./AttachFiles.vue?vue&type=style&index=0&id=221bd572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221bd572",
  null
  
)

export default component.exports